import { API_ROOT, TIMEOUT } from '../../config/config'
import { doDownload, doGet, doPost, doPut, doPostFiles, doDelete, doDeleteBody } from './utils'
import { axiosInterceptors } from '../utils/httpClient'

// const API_ROOT = 'http://localhost:9003/api'
// const API_ROOT2 = 'http://localhost/api'

export const getSchemaReviewSummary = (projectId) => {
  const url = `${API_ROOT}/review/${projectId}/page/summary`
  return doGet(url)
}

export const saveReviewSummary = (request) => {
  const url = `${API_ROOT}/review/review-summary`
  return doPostFiles(url, request)
  // return doPost(url, request)
}

export const saveDraftReviewSummary = (request) => {
  const url = `${API_ROOT}/review/review-summary-draft`
  return doPostFiles(url, request)
  // return doPost(url, request)
}

export const deleteFile = (id, fileId) => {
  // /api/review/review-summary-attachment/{projectVersionId}/{fileid}
  const url = `${API_ROOT}/review/review-summary-attachment/${id}/${fileId}`
  return doDelete(url)
}

export const saveReviewResult = (request) => {
  const url = `${API_ROOT}/review/review-result`
  return doPost(url, request)
}

export const getProjectReview = (projectId) => {
  const url = `${API_ROOT}/review/${projectId}/get-project-review`
  return doGet(url)
}

export const uploadFilesReviewSummary = (id, request) => {
  // /api/review/{projectVersionId}/review-summary-file
  const url = `${API_ROOT}/review/${id}/review-summary-file`
  return doPostFiles(url, request)
}

//หลายโครงการ
export const getSchemaReviewSummaryMuti = (request, pagesize, pagenumber) => {
  const url = `${API_ROOT}/multiple/scrutinize/expert/step3/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doPost(url, request)
}

export const getReviewSummaryMutiData = (request, pagesize, pagenumber) => {
  const url = `${API_ROOT}/multiple/scrutinize/expert/step3/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doPost(url, request)
}

export const saveReviewComment = (request) => {
  const url = `${API_ROOT}/review/multi/review-comment`
  return doPost(url, request)
}

export const saveReviewCommentMulti = (request) => {
  const url = `${API_ROOT}/review/multi/review-comment/all`
  return doPost(url, request)
}

export const saveReviewSummaryMuti = (request) => {
  const url = `${API_ROOT}/multiple/review-summary`
  return doPost(url, request)
}

// บันทึกผลการกลั่นกรอง หลายโครงการ
export const getSchemaReviewResultMulti = (request, pagesize, pagenumber) => {
  const url = `${API_ROOT}/multiple/scrutinize/result/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doPost(url, request)
}

export const getReviewResultMutiData = (request, pagesize, pagenumber) => {
  const url = `${API_ROOT}/multiple/scrutinize/result/widget/pagesize/${pagesize}/pagenumber/${pagenumber}`
  return doPost(url, request)
}

export const saveReviewResultMuti = (request) => {
  // const url = `${API_ROOT}/multiple/scrutinize/result/add`
  const url = `${API_ROOT}/review/multi/review-summary`
  return doPost(url, request)
}

export const downlondDocument = (projectVersionId, projectReviewerId) => {
  const url = `${API_ROOT}/review/${projectVersionId}/${projectReviewerId}/review-summary-file/download`
  return doDownload(url)
}

export const downlondCoverFile = (projectVersionId, projectReviewerId) => {
  const url = `${API_ROOT}/review/${projectVersionId}/${projectReviewerId}/cover-file/download`
  return doDownload(url)
}

export const removeDocumentFile = (request) => {
  const url = `${API_ROOT}/review/review-summary-file`
  return doDeleteBody(url, request)
}

//sub project
export const getSubProjectReviewSummary = (projectVersionId) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/review`
  return doGet(url)
}

export const saveSubProjectReviewSummary = (projectVersionId, request) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/review`
  return doPost(url, request)
}

export const getSubProjectSearchReviewer = (request, pagenum = 0, pagesize = 0) => {
  const url = `${API_ROOT}/subproject/reviewer/search/pagenum/${pagenum}/pagesize/${pagesize}`
  return doPost(url, request)
}

export const uploadDocumentsSubProject = (projectVersionId, request) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/review/attachments`
  return doPost(url, request)
}

export const deleteDocumentSubProject = (projectVersionId, request) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/review/attachments/${request.id}`
  return axiosInterceptors
    .delete(url, { timeout: TIMEOUT, data: request })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      throw error
    })
}

export const renameDocumentSubProject = (projectVersionId, request) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/review/attachments/${request.id}`
  return doPut(url, request)
}

export const downloadDocumentSubProject = (projectVersionId, path) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/review/attachments/download?path=${path}`
  return doDownload(url)
}

export const getApprovalAttachmentsSubProject = (projectVersionId) => {
  const url = `${API_ROOT}/subproject/${projectVersionId}/review/attachments`
  return doGet(url)
}

export const getSchemaUploadFileMoreCoi = (projectId) => {
  const url = `${API_ROOT}/review/${projectId}/page/morefile-coi`
  return doGet(url)
}

export const saveReviewSaveMoreFileCoi = (request) => {
  const url = `${API_ROOT}/review/save-morefile-coi`
  return doPostFiles(url, request)
}

export const saveReviewerSendDate = (projectId, request) => {
  const url = `${API_ROOT}/review/${projectId}/review-summary/list/save`
  return doPost(url, request)
}
